function assert(expr, message) {
    if (!Boolean(expr)) {
        throw new Error(message);
    }
}
function resolve(primary, backup, message) {
    var result = primary || backup();
    assert(result !== undefined, message);
    return result;
}
export { resolve, assert };
//# sourceMappingURL=checks.js.map